module.exports = __webpack_public_path__ + "11560fc1649f3b41ab7b2a09f912b996.jpg";